<template lang="pug">
.timeslot-drop-placeholder(
  v-show="showDropzone"
  :style="getBookingCardStyle(timeslot)"
  )
  .time {{ timeslotStartTime }}
  .drop-label-holder.flex.justify-center.align-center
    span.drop-here-label(v-if="showDropHereLabel") Add booking here
</template>
<script>
import { getBookingCardHeight } from '@/vue/planboard/planboard-calendar/planboardCalendarUtil.js'
import { formatTimeFromUtc } from '@/helpers/dateTimeFormatter.js'

export default {
  name: 'TimeslotDropPlaceholder',
  props: {
    dragInProgress: Boolean,
    timeslot: Object,
    timeslotIndex: Number,
    resourceIndex: Number,
    timeslotIndexOver: Number,
    resourceIndexOver: Number,
  },
  computed: {
    showDropHereLabel() {
      return (
        this.timeslotIndex === this.timeslotIndexOver &&
        this.resourceIndex === this.resourceIndexOver
      )
    },
    showDropzone() {
      return (
        this.dragInProgress &&
        (this.timeslot.BookedProductKeys === null || this.timeslot.BookedProductKeys.length === 0)
      )
    },
    timeslotStartTime() {
      return formatTimeFromUtc(this.$locale)(this.$timezone)(this.timeslot.StartTime)
    },
  },
  methods: {
    getBookingCardStyle(timeslot) {
      return `height: ${getBookingCardHeight(timeslot)}px;`
    },
  },
}
</script>

<style scoped lang="stylus">
@import '~@v/variables.styl'

.timeslot-drop-placeholder
  background-color white
  border-radius 3px
  border-color grey300
  border-style dashed
  width 213px
  position relative
  cursor grab
  margin-left 2px
  position absolute
  border-width 1px
  margin-top 3px
  opacity 0.7

  .time
    font-weight 600
    font-size 16px
    line-height 16px
    margin-top 8px
    margin-left 16px

  .drop-label-holder
    height 80%

    .drop-here-label
      font-size 16px
      color grey600
</style>
